/*eslint-disable*/module.exports={messages:{"welcome-message":"This is the welcome message"}};